import {
  RtcStatsSampler,
  type RtcStatsCollection,
  type RtcStatsDirection,
  type RtcStreamMeasurement,
} from './rtcStats.ts';

export function startRtcStatsPolling(
  peer: RTCPeerConnection,
  direction: RtcStatsDirection,
  onMeasurement: (measurement: RtcStreamMeasurement | undefined) => void,
  intervalMs = 1_000,
): () => void {
  const sampler = new RtcStatsSampler(direction);
  let active = true;
  let polling = false;
  const stop = (): void => {
    if (!active) return;
    active = false;
    clearInterval(timer);
    peer.removeEventListener('connectionstatechange', handleConnectionState);
    sampler.reset();
    onMeasurement(undefined);
  };
  const handleConnectionState = (): void => {
    if (peer.connectionState === 'closed' || peer.connectionState === 'failed' || peer.connectionState === 'disconnected') stop();
  };
  const poll = async (): Promise<void> => {
    if (!active || polling || peer.connectionState === 'closed') return;
    polling = true;
    try {
      const report = await peer.getStats();
      if (!active) return;
      const measurement = sampler.add(report as unknown as RtcStatsCollection);
      if (measurement) onMeasurement(measurement);
    } catch {
      sampler.reset();
    } finally {
      polling = false;
    }
  };
  void poll();
  const timer = setInterval(() => void poll(), intervalMs);
  peer.addEventListener('connectionstatechange', handleConnectionState);
  return stop;
}
